/*
 * Typeguard to ensure the tested subject is a string
 */
export function isString(subject: any): subject is string {
	return typeof subject == 'string';
}

/*
 * Typeguard to ensure the tested subject is a Function
 */
export function isFunction(subject: unknown): subject is Function {
	return typeof subject === 'function';
}
